"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFilenameFromUrl = void 0;
const getFilenameFromUrl = (url) => {
    if (!url) {
        return "";
    }
    return url.substring(url.lastIndexOf("/") + 1);
};
exports.getFilenameFromUrl = getFilenameFromUrl;
